import { InitialState } from '../initialState';
import { Actions, RootAction } from '../actions';
import { getType } from 'typesafe-actions';
import { AccountManagementState } from '../state';
import { AccountManagementDataActions } from '../actions/AccountManagementActions';
import dayjs from 'dayjs';
import { AccountManagementBeneficiaryResponse } from '@tradingblock/types';

export const accountManagementReducer = (
  state = InitialState.accountManagement,
  action: RootAction
): AccountManagementState => {
  switch (action.type) {
    case getType(AccountManagementDataActions.requestAccountDetails): {
      const { accountId } = action.payload;
      const existingState = state || {};
      return {
        ...state,
      };
    }
    case getType(AccountManagementDataActions.receiveAccountDetails): {
      const { accountDetails } = action.payload;
      const existingState = state || {};
      return {
        ...state,
        accountDetails: {
          data: accountDetails,
          isLoaded: true,
        },
      };
    }
    case getType(AccountManagementDataActions.errorAccountDetails): {
      const { error } = action.payload;
      const existingState = state || {};
      return {
        ...state,
        accountDetails: {
          data: error,
          isLoaded: false,
        },
      };
    }
    case getType(AccountManagementDataActions.requestAccountUpdate): {
      return {
        ...state,
      };
    }
    case getType(AccountManagementDataActions.receiveAccountUpdate): {
      const { update } = action.payload;
      return {
        ...state,
        update: {
          isLoading: false,
          isLoaded: true,
          data: update,
        },
      };
    }
    case getType(AccountManagementDataActions.errorAccountUpdate): {
      const { error } = action.payload;
      return {
        ...state,
        update: {
          isLoading: false,
          isLoaded: false,
          data: error,
        },
      };
    }
    case getType(AccountManagementDataActions.requestAccountManagementDetails): {
      return {
        ...state,

        accountManagementDetails: {
          ...state.accountManagementDetails,
          isFetching: true,
        },
      };
    }
    case getType(AccountManagementDataActions.receiveAccountManagementDetails): {
      return {
        ...state,

        accountManagementDetails: {
          ...state.accountManagementDetails,
          isFetching: false,
          details: {
            ...action.payload.response,
            beneficiaries: action.payload.response.beneficiaries
              ? action.payload.response.beneficiaries.map((beneficiary: AccountManagementBeneficiaryResponse) => {
                  let dateModel = {
                    day: dayjs(beneficiary.dateOfBirth).date(),
                    month: dayjs(beneficiary.dateOfBirth).month() + 1,
                    year: dayjs(beneficiary.dateOfBirth).year(),
                  };
                  return {
                    ...beneficiary,
                    dateOfBirth: dateModel,
                  };
                })
              : [],
          },
        },
      };
    }
    case getType(AccountManagementDataActions.errorAccountManagementDetails): {
      return {
        ...state,

        accountManagementDetails: {
          ...state.accountManagementDetails,
          isFetching: false,
          error: action.payload.error,
        },
      };
    }
    case getType(AccountManagementDataActions.requestMakeAccountUpdate): {
      return {
        ...state,
        update: {
          isLoading: true,
          isLoaded: false,
          data: {},
        },
      };
    }
    case getType(AccountManagementDataActions.receiveMakeAccountUpdate): {
      return {
        ...state,
        update: {
          isLoading: false,
          isLoaded: true,
          data: action.payload.response,
          responseCode: action.payload.responseCode,
        },
      };
    }
    case getType(AccountManagementDataActions.errorMakeAccountUpdate): {
      return {
        ...state,
        update: {
          isLoading: false,
          isLoaded: false,
          data: action.payload,
        },
      };
    }
    case getType(AccountManagementDataActions.resetMakeAccountUpdateResponseCode): {
      return {
        ...state,
        update: {
          ...state.update,
          responseCode: undefined,
        },
      };
    }
    case getType(AccountManagementDataActions.requestPendingAccountManagementUpdates): {
      return {
        ...state,
        pendingAccountManagementUpdates: {
          ...state.pendingAccountManagementUpdates,
          isFetching: true,
          data: null,
        },
      };
    }
    case getType(AccountManagementDataActions.receivePendingAccountManagementUpdates): {
      return {
        ...state,
        pendingAccountManagementUpdates: {
          ...state.pendingAccountManagementUpdates,
          isFetching: false,
          data: action.payload.pendingItems,
        },
      };
    }
    case getType(AccountManagementDataActions.errorPendingAccountManagementUpdates): {
      return {
        ...state,
        pendingAccountManagementUpdates: {
          ...state.pendingAccountManagementUpdates,
          isFetching: false,
          error: action.payload.error,
          data: null,
        },
      };
    }

    case getType(AccountManagementDataActions.requestAuthHistory): {
      return {
        ...state,
        authHistory: {
          ...state.authHistory,
          isFetching: true,
        },
      };
    }
    case getType(AccountManagementDataActions.receiveAuthHistory): {
      return {
        ...state,
        authHistory: {
          ...state.authHistory,
          isFetching: false,
          data: action.payload.response,
        },
      };
    }
    case getType(AccountManagementDataActions.errorAuthHistory): {
      return {
        ...state,
        authHistory: {
          ...state.authHistory,
          isFetching: false,
          error: action.payload.error,
        },
      };
    }
    case getType(AccountManagementDataActions.requestAuthHistoryIpGeo): {
      return {
        ...state,
        authHistoryIpGeo: {
          ...state.authHistoryIpGeo,
          isLookupInFlight: true,
        },
      };
    }
    case getType(AccountManagementDataActions.mergeAuthHistoryIpGeo): {
      return {
        ...state,
        authHistoryIpGeo: {
          ...state.authHistoryIpGeo,
          isLookupInFlight: false,
          byIp: { ...state.authHistoryIpGeo.byIp, ...action.payload.merge },
        },
      };
    }
    case getType(AccountManagementDataActions.failAuthHistoryIpGeo): {
      return {
        ...state,
        authHistoryIpGeo: {
          ...state.authHistoryIpGeo,
          isLookupInFlight: false,
          ...(action.payload.clearByIp ? { byIp: {} } : {}),
        },
      };
    }
    case getType(AccountManagementDataActions.endAuthHistoryIpGeoLookup): {
      return {
        ...state,
        authHistoryIpGeo: {
          ...state.authHistoryIpGeo,
          isLookupInFlight: false,
        },
      };
    }
    case getType(AccountManagementDataActions.setAuthHistorySessionClientIp): {
      const rawIp = action.payload.ip;
      const trimmed = rawIp != null ? String(rawIp).trim() : '';
      const hasIp = trimmed !== '';
      return {
        ...state,
        authHistoryIpGeo: {
          ...state.authHistoryIpGeo,
          sessionClientIp: hasIp ? trimmed : undefined,
          sessionClientIpSource: hasIp ? action.payload.source : undefined,
        },
      };
    }
    case getType(AccountManagementDataActions.clearAuthHistoryLoginIpGeo): {
      return {
        ...state,
        authHistoryIpGeo: {
          ...state.authHistoryIpGeo,
          byIp: {},
          isLookupInFlight: false,
        },
      };
    }
    case getType(AccountManagementDataActions.resetAuthHistoryIpGeo): {
      return {
        ...state,
        authHistoryIpGeo: {
          byIp: {},
          isLookupInFlight: false,
          sessionClientIp: undefined,
          sessionClientIpSource: undefined,
        },
      };
    }
    case getType(Actions.signout): {
      return {
        ...state,
        authHistoryIpGeo: InitialState.accountManagement.authHistoryIpGeo,
      };
    }
    default: {
      return state;
    }
  }
};
